import { render, staticRenderFns } from "./SfTable.vue?vue&type=template&id=4b7a0269&"
import script from "./SfTable.vue?vue&type=script&lang=ts&"
export * from "./SfTable.vue?vue&type=script&lang=ts&"
import style0 from "./SfTable.vue?vue&type=style&index=0&id=4b7a0269&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports